'use strict';

module.exports = require('./clone').clone;
